import { useState, useCallback } from 'react';
import { digitsSum, TEST_CASES } from '../algorithms/digitsSum';

/**
 * Hook que encapsula el estado y la lógica del ejercicio digitsSum.
 * Expone el input, el resultado y los casos de prueba ya evaluados.
 */
export function useDigitsSum() {
  const [input, setInput] = useState('');

  const handleChange = useCallback((value) => {
    setInput(value);
  }, []);

  // Evalúa la función solo si hay un número válido
  const rawValue = parseInt(input, 10);
  const isValid = input !== '' && !isNaN(rawValue) && rawValue >= 0;
  const result = isValid ? digitsSum(rawValue) : null;

  // Evalúa todos los casos de prueba
  const testResults = TEST_CASES.map((tc) => ({
    ...tc,
    actual: digitsSum(tc.input),
    pass: digitsSum(tc.input) === tc.expected,
  }));

  return { input, handleChange, result, isValid, testResults };
}
